<template>
    <v-container fluid fill-height px-0 class="main-container container-fixed d-block">
        <div class="content-block">
            <v-flex class="d-flex justify-space-between align-center mx-6">
                <div class="arrow-btn main-text d-inline-flex" @click="back">
                    <div v-html="require('!html-loader!@/assets/icons/arrow_down_icon.svg')" class="rotate-90 mr-2" />
                </div>
                <div class="title-text d-inline-flex">
                    {{ deviceData.name }}
                </div>
                <div class="d-inline-flex"></div>
            </v-flex>
            <v-layout row v-if="deviceData" class="ma-0 px-6 mb-2 w-100 justify-center">
                <span class="main-text ml-1" v-if="deviceData.location">
                    ({{ deviceData.location }})
                </span>
            </v-layout>
            <v-layout column ma-0 class="main-text mb-5 w-100 history-list scrollbar-block" v-if="heatingHistory.length > 0">
                <v-flex
                    xs12
                    v-for="(heating, index) in heatingHistory"
                    :key="index" class="history"
                    :class="{'history__high': heating.new_day}"
                >
                    <v-layout v-if="heating.new_day" class="history__title main-text">
                        {{heating.new_day}}
                    </v-layout>
                    <v-flex class="history-row">
                        <div class="history-row__time flex-row align-center">
                            <div class="d-inline-flex" v-if="heating.state.heating">
                                <div v-html="require('!html-loader!@/assets/icons/flame_icon.svg')" class="img-container mr-2" />
                            </div>
                            <div class="d-inline-flex" v-else>
                                <div v-html="require('!html-loader!@/assets/icons/flame_disabled_icon.svg')" class="img-container mr-2" />
                            </div>
                            <div class="time-row bold-text d-inline-flex align-center">
                                время: <span class="main-text ml-1">{{heating.start_updated}}</span>
                            </div>
                        </div>
                    </v-flex>
                </v-flex>
            </v-layout>
            <div class="d-flex align-center history-list__error" v-else>
                <v-flex class="d-block text-center">
                    <div>
                        <div v-html="require('!html-loader!@/assets/images/error.svg')" class="img-container mb-8" />
                        <div class="common-text text-center">
                            Нет уведомлений
                        </div>
                    </div>
                </v-flex>
            </div>
            <ModalWaiting v-model="openModalWaiting"></ModalWaiting>
        </div>
    </v-container>
</template>

<script>
import ModalWaiting from "@/components/modals/ModalWaiting";
import {eventBus} from "@/main";
import {getTimeFromDate} from "@/utils";
import {timeWithTZ} from "@/utils";

export default {
    name: "HeatingHistory",
    components: {
        ModalWaiting,
    },
    data() {
        return {
            deviceUID: null,
            deviceData: {},
            heatingHistory: [],
            openModalWaiting: false,
        };
    },
    created() {
        eventBus.$on("reconnect", this.loadPage);
    },
    beforeDestroy() {
        eventBus.$off("reconnect", this.loadPage);
    },
    mounted() {
        this.loadPage();
    },
    methods: {
        loadPage() {
            this.deviceUID = this.$route.params.id;
            if (this.deviceUID) {
                this.getHeatings();
            }
        },
        getHeatings() {
            this.heatingHistory = [];
            this.openModalWaiting = true;
            this.$http.get('/devices/home/heating-history/' + this.deviceUID + '/')
                .then((res) => {
                    this.deviceData = res.data.device;
                    this.heatingHistory = res.data.actions;
                    this.heatingHistory.forEach((heating, index) => {
                        heating.start_updated = this.getTime(heating.date);
                        if (index > 0) {
                            if (this.checkDay(heating.date) != this.checkDay(this.heatingHistory[index - 1].date)) {
                                heating.new_day = this.checkDay(heating.date);
                                heating.new_day = this.reverseDate(heating.new_day);
                            }
                        } else {
                            heating.new_day = this.checkDay(heating.date);
                            heating.new_day = this.reverseDate(heating.new_day);
                        }
                    });
                })
                .finally(() => {
                    this.openModalWaiting = false;
                });
        },
        getTime(time) {
            return getTimeFromDate(time);
        },
        checkDay(day) {
            return timeWithTZ(day).split('T')[0];
        },
        reverseDate(time) {
            const [year, month, day] = time.split("-");
            return day + "." + month + "." + year;
        },
        formattedDuration(val) {
            val = parseInt(val);
            if (val >= 60) {
                let minutes = Math.floor(val / 60);
                let seconds = val % 60;
                let hours = Math.floor(minutes / 60);
                minutes = minutes % 60;
                let row = "";
                if (hours) {
                    row = hours + " ч.";
                }
                if (minutes) {
                    if (hours) {
                        row += " " + minutes + " мин.";
                    }
                    else {
                        row += minutes + " мин.";
                    }
                }
                if (seconds) {
                    if (hours || minutes) {
                        row += " " + seconds + " сек.";
                    } else {
                        row += seconds + " сек.";
                    }
                }
                return row;
            }
            return val + " сек.";
        },
        back() {
            this.$router.push({ name: "homepage" });
        },
    },
}
</script>

<style lang="scss" scoped>
.rotate-90.v-image {
    transform: rotate(90deg);
}

.img-container {
    height: 30px;
    width: 30px;
}
</style>